import { defineComponent, ICrop, ICroppingComposition } from "../../../omnia";
import { IFieldsService } from "../../../types";

interface IEditCroppingComposition extends ICroppingComposition {
    availableCrops: ICrop[];
}

export class EditCompositionCtrl {


    static create(): ng.IDirective {

        return defineComponent(EditCompositionCtrl, "app/fields/edit/cropping/composition/composition.html", {
            composition: "=",
            mainCrop: "=",
            showErrors: "=",
            readOnly: "="
        });

    };


    private mainCrop: ICrop

    private autoManagePct: boolean;

    composition: IEditCroppingComposition[];
    selectedCrop: ICroppingComposition;


    static $inject = ["$scope", "OmniaFieldsService"];


    constructor($scope: ng.IScope, private svc: IFieldsService) {

        $scope.$watchGroup(["vm.mainCrop", "vm.composition"], () => this.setup());
    }


    private setup() {

        if (!omnia.isArray(this.composition)) this.composition = []

        this.autoManagePct = (this.composition.length == 0) || ((this.composition.length == 1) && (this.composition[0].Percentage == 1));

        var crops = this.svc.crops;

        this.composition.forEach(c => c.Crop = crops.find(i => i.CropId == c.CropId));

    }

    getAvailableCrops(c: IEditCroppingComposition): ICrop[] {

        if (!c) return null;

        if (!c.availableCrops) {

            var crops = this.svc.crops;

            var grass = this.mainCrop && this.mainCrop.Grass;
            var coverCrop = this.mainCrop && this.mainCrop.CoverCrop;

            crops = crops.filter(c => (grass && c.GrassComposition) || (coverCrop && c.CoverCropComposition));

            var used = this.composition.filter(cc => c != cc).map(cc => cc.Crop);

            crops = crops.filter(c => used.every(u => u.CropId != c.CropId));

            c.availableCrops = crops;

        }

        return c.availableCrops;

    }

    resetAvailableCrops() {
        this.composition.forEach(c => c.availableCrops = null);
    }

    canAddNewCrop(): boolean {

        return this.composition && this.composition.every(c => (!!c.Crop) && (c.Percentage > 0));

    }

    addNewCrop() {

        var cmp = {

            CropId: null,
            Crop: null,
            Percentage: null,

            availableCrops: null,

        };

        if (this.autoManagePct) {

            var n = this.composition.length;

            if (!n) {
                cmp.Percentage = 1;
            }
            else {
                var pct = Math.round((1 / (n + 1)) * 100) / 100;
                this.composition.forEach(c => c.Percentage = pct);
                cmp.Percentage = 1 - this.composition.map(c => c.Percentage).reduce((p1, p2) => p1 + p2);
            }

        };

        this.composition.push(cmp);

        this.selectedCrop = cmp;

    }

    selectItem(c: ICroppingComposition) {

        this.selectedCrop = c;

    }

    removeCrop(cmp: ICroppingComposition) {

        this.composition.remove(i => i == cmp);
        if (this.selectedCrop == cmp) this.selectedCrop = null;
        this.resetAvailableCrops();

    }

    isEmpty(): boolean {
        return (!this.composition) || (this.composition.length == 0);
    }

    getCurrentTotal(): number {
        return getCompositionTotalPct(this.composition)
    }

    updateCrop(c: IEditCroppingComposition) {
        c.CropId = (c.Crop ? c.Crop.CropId : null);
        this.resetAvailableCrops();
    }

    updateCropPct(c: ICroppingComposition) {
        this.autoManagePct = false;
    }

}

export function getCompositionTotalPct(composition: ICroppingComposition[]): number {

    let total: number

    if (composition && composition.length) {
        total = Math.round(composition.map(c => c.Percentage).reduce((p1, p2) => (p1 || 0) + (p2 || 0)))
    }

    return total

}


